import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

const ArchiveTenantModal = ({ open, onClose, onConfirm, tenant }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Archive Tenant</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to archive <strong>{tenant?.name}</strong>?
          This will remove the tenant from the active view.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Archive
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveTenantModal;